import { Injectable } from '@angular/core';
import type { ColorSelectionOption } from '@configuration/wizard/models/wizard-model.interface';

@Injectable({ providedIn: 'root' })
export class DyeColorModel {
  private static readonly additionalDyeColors: { [key: string]: ColorSelectionOption[] } = {
    '274': [
      { label: 'color.white', id: 'cold_white', value: '#FCFFFF', color: 'cold_white' }, // white with 1% cyan
      { label: 'color.gray_yellow', id: 'gray_yellow', value: ['#8E9291', '#FFFF00'], color: 'gray_yellow' },
    ]
  }

  public static getAdditionalDyeColorsByArticleSeries(series: string) {
    if (DyeColorModel.additionalDyeColors.hasOwnProperty(series)) {
      return DyeColorModel.additionalDyeColors[series];
    }
    return [];
  }
}
